// import * as React from "react"
// import * as TabsPrimitive from "@radix-ui/react-tabs"

// import { cn } from "@/lib/utils"

// const Tabs = TabsPrimitive.Root

// const TabsList = React.forwardRef(({ className, ...props }, ref) => (
//   <TabsPrimitive.List
//     ref={ref}
//     className={cn(
//       "inline-flex h-9 items-center justify-center rounded-lg bg-transparent p-1 text-muted-foreground",
//       className
//     )}
//     {...props} />
// ))
// TabsList.displayName = TabsPrimitive.List.displayName

// const TabsTrigger = React.forwardRef(({ className, ...props }, ref) => (
//   <TabsPrimitive.Trigger
//     ref={ref}
//     className={cn(
//       "inline-flex items-center justify-center whitespace-nowrap px-3 py-1 last:border-r-0 z-10 border-r !border-r-gray-600 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:border-b border-cyellow data-[state=active]:text-cyellow data-[state=active]:shadow",
//       className
//     )}
//     {...props} />
// ))
// TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

// const TabsContent = React.forwardRef(({ className, ...props }, ref) => (
//   <TabsPrimitive.Content
//     ref={ref}
//     className={cn(
//       "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
//       className
//     )}
//     {...props} />
// ))
// TabsContent.displayName = TabsPrimitive.Content.displayName

// export { Tabs, TabsList, TabsTrigger, TabsContent }

import * as React from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";
import { cn } from "@/lib/utils";

const STORAGE_KEY = "tabs-data"; 

const Tabs = ({
  valueKey = "global-tab",
  tabName = "default",
  defaultValue,
  onValueChange,
  ...props
}) => {
  const [value, setValue] = React.useState(defaultValue);

  React.useEffect(() => {
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
      const saved = stored[valueKey]?.[tabName];
      if (saved) {
        setValue(saved);
        if (onValueChange) onValueChange(saved);
      } else {
        setValue(defaultValue);
        if (onValueChange) onValueChange(defaultValue);
      }
    } catch (e) {
      setValue(defaultValue);
      if (onValueChange) onValueChange(defaultValue);
    }
  }, [defaultValue, valueKey, tabName, onValueChange]);

  const handleChange = (val) => {
    setValue(val);
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
      if (!stored[valueKey]) stored[valueKey] = {};
      stored[valueKey][tabName] = val;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
    } catch (e) {
      console.error("Tabs save error:", e);
    }
    if (onValueChange) onValueChange(val);
  };

  return (
    <TabsPrimitive.Root value={value} onValueChange={handleChange} {...props}>
      {props.children}
    </TabsPrimitive.Root>
  );
};

const TabsList = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      "inline-flex h-9 items-center justify-center rounded-lg bg-transparent p-1 text-muted-foreground",
      className
    )}
    {...props}
  />
));
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "inline-flex items-center justify-center whitespace-nowrap px-3 py-1 last:border-r-0 z-10 border-r !border-r-gray-600 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:border-b border-cyellow data-[state=active]:text-cyellow data-[state=active]:shadow",
      className
    )}
    {...props}
  />
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      className
    )}
    {...props}
  />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

export { Tabs, TabsList, TabsTrigger, TabsContent };
